var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_2390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57756 2.5003L14.9282 13.5003C14.9867 13.6016 15.0175 13.7166 15.0175 13.8336C15.0175 13.9506 14.9867 14.0656 14.9282 14.167C14.8697 14.2683 14.7856 14.3525 14.6842 14.411C14.5829 14.4695 14.4679 14.5003 14.3509 14.5003H1.64956C1.53254 14.5003 1.41758 14.4695 1.31623 14.411C1.21489 14.3525 1.13073 14.2683 1.07222 14.167C1.01371 14.0656 0.982909 13.9506 0.98291 13.8336C0.982911 13.7166 1.01372 13.6016 1.07223 13.5003L7.42289 2.5003C7.48141 2.39896 7.56557 2.31481 7.66691 2.2563C7.76825 2.19779 7.88321 2.16699 8.00023 2.16699C8.11725 2.16699 8.2322 2.19779 8.33355 2.2563C8.43489 2.31481 8.51905 2.39896 8.57756 2.5003ZM2.80423 13.167H13.1962L8.00023 4.16696L2.80423 13.167ZM7.33356 11.167H8.66689V12.5003H7.33356V11.167ZM7.33356 6.5003H8.66689V9.83363H7.33356V6.5003Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_2390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLine);
export default __webpack_public_path__ + "static/media/alert-line.e94326715ed87d25b35dc6f24f8af35c.svg";
export { ForwardRef as ReactComponent };